import request from '@/server/request'

export default {
  async loadGreenhouse ({ rootGetters }, payload) {
    return request({ entity: 'customer.greenhouse', action: 'list' }, rootGetters['admin/getAccessToken'], 'GET', payload)
  },
}
